module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"or":"oder"},"en":{"or":"or"}}')
  delete Component.options._Ctor
}
